import { CurrencyPipe, DecimalPipe } from '@angular/common';
import { SortDescriptor, SortOrder } from '../sort';
import { BillingFrequency, Currency } from '../types';
import { formatBillingFrequency } from './format-billing-frequency';
import { convertCentsToDollars } from './price-utils';

export function capitalize(value: string): string {
  if (value) {
    return value.charAt(0).toUpperCase() + value.slice(1);
  }
  return value;
}

export function sortedWithState(items: any[], sortState: SortDescriptor): any[] {
  if (sortState.order === SortOrder.Ascending) {
    return sortedAscendingByField([...items], sortState.fieldname);
  } else {
    return sortedDescendingByField([...items], sortState.fieldname);
  }
}

export function sortedAscendingByField(items: any[], fieldName: string): any[] {
  try {
    return items.sort((a, b) => a[fieldName].localeCompare(b[fieldName]));
  } catch (error) {
    return items.sort(function (a: any, b: any): number {
      return a[fieldName] > b[fieldName] ? 1 : b[fieldName] > a[fieldName] ? -1 : 0;
    });
  }
}

export function sortedDescendingByField(items: any[], fieldName: string): any[] {
  try {
    return items.sort((a, b) => b[fieldName].localeCompare(a[fieldName]));
  } catch (error) {
    return items.sort(function (a: any, b: any): number {
      return a[fieldName] < b[fieldName] ? 1 : b[fieldName] < a[fieldName] ? -1 : 0;
    });
  }
}

export function formatDisplayPrice(
  value: any,
  currency: Currency | string,
  billingFrequency?: BillingFrequency,
  isCents = true,
  translateZero = true,
  displaySymbol = true,
): string {
  let price = 'Contact Sales';
  const display: 'code' | 'symbol' | 'symbol-narrow' | boolean = displaySymbol === true ? 'symbol' : 'code';

  if (value) {
    if (isCents) {
      value = convertCentsToDollars(Number(value));
    }
    if (!currency) {
      price = new DecimalPipe('en-US').transform(value, '1.2-2');
    } else {
      price = new CurrencyPipe('en-US').transform(value, currency, display, '1.2-2');
    }
    if (billingFrequency) {
      price = price + ' ' + formatBillingFrequency(billingFrequency);
    }
  }

  if (translateZero) {
    if (value < 0) {
      return 'Contact Sales';
    }
    if (value === 0) {
      return 'Free';
    }
  }
  if (value === 0) {
    return currency
      ? new CurrencyPipe('en-US').transform(value, currency, display, '1.2-2')
      : new DecimalPipe('en-US').transform(value, '1.2-2');
  }

  return price;
}
